import { useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { ResetBtn, UseBtn } from 'libs/ui';
import { Container, Input, ParkingFilter, ButtonsContainer, DictFilter } from 'libs/form';

const initial = {};

const BenefitTypeFilter = (props) => {
  const { className, setInitial, reset, handleSubmit, theme } = props;

  const { t } = useTranslation();

  // did mount
  useEffect(() => {
    setInitial(initial);
    return () => {
      reset();
      setInitial(initial);
    };
  }, []);

  const cl = `${className} cp-filter`;

  return (
    <Container theme={theme} className={cl}>
      <form onSubmit={handleSubmit}>
        <Input name="name" label={t('form.Клиент')} placeholder={t('form.Клиент')} type="text" />

        <DictFilter dict="benefit_types.status" />

        <Input width={'180px'} name="amount" label={t('grid.Сумма скидки, ₽')} placeholder={t('grid.Сумма скидки')} type="text" naturalNumber />

        <Input width={'200px'} name="min_amount" label={t('grid.Минимальная сумма, ₽')} placeholder={t('grid.Минимальная сумма')} type="text" naturalNumber />

        <Input name="fn" label={t('form.Номер ФН')} placeholder={t('form.Номер ФН')} type="text" withoutLetters />

        <ParkingFilter />
        <ButtonsContainer>
          <ResetBtn onClick={reset} theme={theme} />
          <UseBtn />
        </ButtonsContainer>
      </form>
    </Container>
  );
};

export default reduxForm({
  form: 'benefit_typesFilter',
  // destroyOnUnmount: false,
  initialValues: initial,
})(BenefitTypeFilter);
